import { Button } from "antd";
import React from "react";
interface ButtonPrimaryProps {
  onClick?: () => void;
  title: string;
  disabled?: boolean;
  className?: string;
  style?: any;
}
const GreyButton = ({ ...props }: ButtonPrimaryProps) => {
  return (
    <Button
      {...props}
      title=""
      className={`takaful--grey-button ${props.className}`}
    >
      {props.title}
    </Button>
  );
};

export default GreyButton;
